// extracted by mini-css-extract-plugin
export var measureBox = "_69-0";